// extracted by mini-css-extract-plugin
module.exports = {"Player":"Player_Player__34S_z","close":"Player_close__3jlOs","playerName":"Player_playerName__1sgx_","card":"Player_card__2IJQP"};